/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/css';

const cardsContainer = css({
  margin: '0.5rem 0',
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
  '@media (max-width: 768px)': {
    flexDirection: 'column',
  },
});

const icon = css({
  width: '20px',
  display: 'inline',
  marginLeft: '10px',
  '@media (max-width: 768px)': {
    marginLeft: '30px',
  },
});

export const SelectTemplateStyles = {
  icon,
  cardsContainer,
};
